import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Landing from "./Landing";
import PrivateRoute from "./PrivateRoute";
import Home from './Home';
import TestPage from './TestPage'; // Import the TestPage component
import { AuthProvider, useAuth } from "./AuthContext";
import DevLogin from "./DevLogin"; // Ensure this component exists

function AppContent() {
  const { showDevLogin, isLocalhost } = useAuth();

  return (
    <>
      {isLocalhost && showDevLogin && <DevLogin />}
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/test-page" element={<PrivateRoute><TestPage /></PrivateRoute>} /> {/* Add the route for TestPage within PrivateRoute */}
        </Routes>
      </Router>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;